import type { Dispatch, ReactNode, SetStateAction } from 'react';
import { createContext, useContext, useMemo, useState } from 'react';

import type { SymbolKey } from '@/entities/symbol';

interface AppContextType {
  onSubmit: ((items: SymbolKey[]) => void) | undefined;
  setOnSubmit: Dispatch<SetStateAction<((items: SymbolKey[]) => void) | undefined>>;
}

const AddToAppContext = createContext<AppContextType | undefined>(undefined);

export const AddToAppContextProvider = ({ children }: { children: ReactNode }) => {
  const [onSubmit, setOnSubmit] = useState<(items: SymbolKey[]) => void>();

  const value = useMemo(
    () => ({
      onSubmit,
      setOnSubmit
    }),
    [onSubmit, setOnSubmit]
  );
  return <AddToAppContext.Provider value={value}>{children}</AddToAppContext.Provider>;
};

export const useAddToAppContext = () => {
  const context = useContext(AddToAppContext);
  if (!context) throw new Error('useChartContext must be used within ChartProvider');
  return context;
};
